import { AxiosError } from "axios";

import httpRequest from "@/auth/http-client";
import { IChat } from "@/interfaces/chat.interfaces";
import { ConversationFilter, ConversationView } from "@/types/conversation-filters.types";
import { PaginatedResponse } from "@/types/requests.types";

const baseConversationUrl = "api/v1/conversation";

const EMPTY_PAGE: PaginatedResponse<IChat> = {
  items: [],
  totalCount: 0,
  pageNumber: 1,
  pageSize: 0,
  hasNextPage: false,
  hasPreviousPage: false,
};

export type FilteredConversationsParams = {
  platformId: number;
  view: ConversationView;
  filter: ConversationFilter;
  pageNumber: number;
  pageSize: number;
};

export async function getFilteredConversations({
  platformId,
  view,
  filter,
  pageNumber,
  pageSize,
}: FilteredConversationsParams): Promise<PaginatedResponse<IChat>> {
  const queryParams = new URLSearchParams({
    view,
    filter,
    pageNumber: String(pageNumber),
    pageSize: String(pageSize),
  });

  try {
    const page = await httpRequest.get<PaginatedResponse<IChat>>(
      `${baseConversationUrl}/all/${platformId}/filtered?${queryParams}`
    );

    if (!page?.items) return { ...EMPTY_PAGE, pageNumber, pageSize };

    return page;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response?.status === 404) {
        return { ...EMPTY_PAGE, pageNumber, pageSize };
      }
      throw new Error(error.response?.data?.message || "Failed to fetch conversations");
    }
    throw new Error("Failed to fetch conversations");
  }
}
